import React from 'react';
import PropTypes from 'prop-types';

import { CredentialCard } from '../../credential';
import { DatasetCard } from '../../dataset';
import { StorageResourceCard } from '../../storage';
import { StreamCard } from '../../stream';
import { SubscriptionCard } from '../../subscription';
import { WorkloadCard } from '../../workload';

import { ResourceCard } from '.';

export default function ResourcePolyCard(props) {
  const { resource } = props;
  
  switch(resource.ResourceType) {
    case "Credential":
      return(<CredentialCard resource={resource}/>);
    case "Dataset":
      return(<DatasetCard resource={resource}/>);
    case "Datastore":
      return(<StorageResourceCard resource={resource}/>);
    case "LandingZone":
      return(<StorageResourceCard resource={resource}/>);
    case "Stream":
      return(<StreamCard resource={resource}/>);
    case "Subscription":
      return(<SubscriptionCard resource={resource}/>);
    case "Workload":
      return(<WorkloadCard resource={resource}/>);
    default:
      return(<ResourceCard resource={resource}/>);
  }
}

ResourcePolyCard.propTypes = {
  resource: PropTypes.object,
};

ResourcePolyCard.defaultProps = {
};

